export default __webpack_public_path__ + "static/media/ic_percentage.cb643b1b.svg";